import React from 'react'
import {Link} from "react-router-dom";
function Counsellor() {
  return (
    <div>
      <div className='counsellor_background py-4 mb-5'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10 text-center'>
            <h1 className='display-5'>Talk to our Counsellor</h1>
            <p className='py-2'>Make an appointment with one of our certified counselors to get individualized assistance with your academic and career goals</p>
            <Link to='/contact'>
            <button className="text-white shadow-sm mx-4 fs-5 px-5 pt-1 pb-2 Navbar_button">Contact Us</button>
            </Link>
            </div>
            <div className='col-md-1'></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Counsellor
